import { useState, useEffect, useRef } from 'react';
export const useFetch = (initialUrl, initialOptions = {}) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [url, setUrl] = useState(initialUrl);
  const [options, setOptions] = useState(initialOptions);
  const [status, setStatus] = useState('');

  const fetchData = async () => {
    setIsLoading(true);
    try {
      let res;
      if (options.method) {
        if (options.method === 'POST' && options.body) {
          res = await fetch(url, options);
          setIsLoading(false);
        }
      } else {
        res = await fetch(url, {
          method: 'GET',
        });
        setIsLoading(false);
      }

      const json = await res.json();
      setStatus(res.status);
      setData(json);
    } catch (err) {
      setError(err);
    }
  };
  useEffect(() => {
    if (url !== '') {
      fetchData();
    }
  }, [url, options]);

  return {
    data,
    error,
    isLoading,
    setUrl,
    setOptions,
    options,
    status,
  };
};
